import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Oblast_firme, ApiClientService } from '../../services/api-client.service';

@Component({
  selector: 'app-oblasti-firme',
  templateUrl: './oblasti-firme.component.html',
  styleUrls: ['./oblasti-firme.component.scss']
})
export class OblastiFirmeComponent {
  @ViewChild('oblastiGrid', { static: false }) oblastiGrid: any;

  gridData: Oblast_firme[] = [];
  loading = false;
  isCreatePopupVisible = false;
  loadPanelPosition = { of: '#oblastiGrid' };

  oblastForm!: FormGroup;

  constructor(
    private apiClient: ApiClientService,
    private fb: FormBuilder
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.loadOblasti();
  }

  initializeForm() {
    this.oblastForm = this.fb.group({
      oblast: ['', Validators.required]
    });
  }

  async loadOblasti() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.oblastiFirmeAll();
    } catch (error) {
      console.error('Error loading oblasti:', error);
    } finally {
      this.loading = false;
    }
  }

  onAddClick() {
    this.oblastForm.reset();
    this.isCreatePopupVisible = true;
  }

  async createOblast() {
    if (this.oblastForm.valid) {
      this.loading = true;
      try {
        const formData = this.oblastForm.value;
        await this.apiClient.oblastiFirmePOST(formData);
        this.isCreatePopupVisible = false;
        this.oblastForm.reset();
        this.loadOblasti(); // Refresh grid
      } catch (error) {
        console.error('Error creating oblast:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  onRefreshClick() {
    this.loadOblasti();
  }

  onCreatePopupHidden() {
    this.isCreatePopupVisible = false;
  }
}
